'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setEmitRule = setEmitRule;
exports.default = buildComponent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styletronUtils = require('styletron-utils');

var emitRule = void 0;

function setEmitRule(cb) {
  emitRule = cb;
}

/* eslint-disable guard-for-in */
function buildComponent(combinedRules) {
  var labelsToClassNames = {};
  combinedRules.forEach(function (ruleDesc) {
    var label = ruleDesc[0];
    labelsToClassNames[label] = label;
    var camelCaseKey = label.split(/-+/).map(function (s, i) {
      return i > 0 ? '' + s[0].toUpperCase() + s.slice(1) : s;
    }).join('');
    labelsToClassNames[camelCaseKey] = label;
  });

  var customCssForMediaQueries = Object.keys(combinedRules.mediaQueries).reduce(function (m, label) {
    m['css' + label] = combinedRules.mediaQueries[label];
    m['css' + label[0].toUpperCase() + label.slice(1)] = combinedRules.mediaQueries[label];
    return m;
  }, {});

  var B = function B(props, ctx) {
    var Comp = 'div';
    var newProps = props.props || {};
    var classNames = props.className && [props.className] || [];
    for (var prop in props) {
      var ruleLabel = labelsToClassNames[prop];
      if (ruleLabel) {
        if (props[prop]) {
          classNames.push(ruleLabel);
          if (emitRule) emitRule(ruleLabel);
        }
      } else {
        switch (prop) {
          case 'className':
          case 'props':
            break;
          case 'css':
            classNames.push(styletronUtils.injectStylePrefixed(ctx.styletron, props[prop]));
            break;
          case 'component':
            Comp = props[prop];
            break;
          default:
            if (customCssForMediaQueries[prop]) {
              classNames.push(styletronUtils.injectStylePrefixed(ctx.styletron, props[prop], customCssForMediaQueries[prop]));
            } else {
              newProps[prop] = props[prop];
            }
        }
      }
    }
    return _react2.default.createElement(Comp, Object.assign({ className: classNames.join(' ') }, newProps));
  };
  B.contextTypes = { styletron: _react2.default.PropTypes.object };
  return B;
}


//////////////////
// WEBPACK FOOTER
// ./~/reta/component-builder.js
// module id = 350
// module chunks = 0